import React, { useEffect, useState } from 'react';

import { Select } from 'antd';
import { FormSelect, Col } from '@digital/ui';

import './styles.css';
import TipoOptions from '@app/types/core.types';

import { Visibility } from './Visibility';

const { Option } = Select;

interface IFormSelectFilterProps {
    name: string;
    label?: string;
    span?: React.ComponentProps<typeof Col>['span'];
    visible?: boolean;
    dataOptions?: (page?: number) => Promise<TipoOptions[]>;
}

export const FormSelectFilter = ({
    visible = true,
    label,
    name,
    span,
    dataOptions,
}: IFormSelectFilterProps) => {

    const [options, setOptions] = useState<TipoOptions[]>([]);
    const [filterOptions, setFilterOptions] = useState<TipoOptions[]>([]);

    const [isOpen, setIsOpen] = useState<boolean>(false);


    useEffect(() => {
        dataOptions && dataOptions()
            .then((value) => {
                setOptions(value);
            });
    }, []);

    useEffect(() => {
        setIsOpen(false);
        if (filterOptions.length > 0) {
            setIsOpen(true);
        }
    }, [filterOptions]);

    return (
        <Visibility visible={visible} >
            <FormSelect
                mode="multiple"
                label={label}
                options={filterOptions}
                name={name}
                span={span}
                allowClear
                optionFilterProp="children"
                filterOption={false}
                showSearch
                onSearch={(values) => {
                    setIsOpen(false);
                    setFilterOptions([]);
                    if (values.length >= 3) {
                        let f = options.filter(f => f.text.toLowerCase().includes(values.toLowerCase()));
                        if (f.length < 1000) {
                            setFilterOptions(f);
                        }
                    }
                }}
                onDropdownVisibleChange={(values) => {
                    console.log('onDropdownVisibleChange', values);
                    if (values == false) {
                        setFilterOptions([]);
                    }
                }}
                open={isOpen}
            >
                {filterOptions.map(option => (
                    <Option key={option.value.toString()} value={option.value.toString()}>{option.text}</Option>
                ))}
            </FormSelect>
        </Visibility>
    );
};






// EXAMPLE
// <FormSelectFilter
//     name="FornecedoresId"
//     label="Fornecedor"
//     // dataOptions={(page) => {
//     //   return getAllFornecedoresOptions(page);
//     // }}
//     paginationOptions={fornecedoresOptions}
//     span={6}
// />
